import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'jsonapi-list-template',
  template: `
    <label class="mb-0">
      {{ to.label }}
    </label>
    <ng-container *ngFor="let item of model">
      <div>
        <span>#{{item.id}}: </span>
          {{ this.stringify(item.attributes) }}
      </div>
    </ng-container>
    <div class="mb-5"></div>
  `,
})
export class JsonapiListTemplateTypeComponent extends FieldArrayType {
  stringify(json: any): string {
    return JSON.stringify(json);
  }
}
